import { withMaybe } from "@viagogo/core/ui";
import type { LinkItem } from "src/http/api-types";
import { FormatContent } from "src/shared/components/content";
import { LinksGrid } from "src/website-apps/shared/components/LinksGrid";

interface Props {
  categoryName: Maybe<string>;
  venues: readonly LinkItem[];
}

/**
 * Returns a Links Grid for Venues Data if Present
 */
export const MaybeVenuesLinksGrid = withMaybe<Props>(() => false)((props) => (
  <LinksGrid title={<FormatContent id="cid$#1810830#" params={props.categoryName ?? ""} />} links={props.venues} />
));
